"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSeoCleanURL = void 0;
var Localization_1 = require("../constants/Localization");
var filters_1 = require("./filters");
var SeoCleanURLTranslations_1 = require("../constants/SearchPageCategories/SeoCleanURLTranslations");
var resolveSeoCleanURL = function (seoCleanLocationSubDirectoryPrefix, previousLanguage, currentLanguage, deal, locationPathName, address) {
    var prefix = Localization_1.PagePrefixTranslations[previousLanguage][currentLanguage][locationPathName];
    var result = filters_1.findElement(SeoCleanURLTranslations_1.SeoCleanURLTranslations, seoCleanLocationSubDirectoryPrefix, currentLanguage);
    replaceURL(prefix, result, currentLanguage, address);
};
exports.resolveSeoCleanURL = resolveSeoCleanURL;
var replaceURL = function (prefix, url, language, address) {
    var _a;
    var newLocation;
    if (language !== Localization_1.LocalizationSettings.defaultLanguage) {
        newLocation = "/" + language + "/" + prefix + "/" + url + filters_1.trimAddressNamePrefix(address);
    }
    else {
        newLocation = "/" + prefix + "/" + url + filters_1.concatAddressNameWithPrefix(address, language)[0];
    }
    if (!!sessionStorage.getItem('prevURL')) {
        var prevURL = JSON.parse((_a = sessionStorage.getItem('prevURL')) !== null && _a !== void 0 ? _a : '');
        newLocation += prevURL.search;
    }
    location.replace(newLocation);
};
